import { useEffect, useState } from "react";

/** Breakpoint where we switch from mobile to desktop layout (1024px = Tailwind `lg`) */
const DESKTOP_BREAKPOINT = "(min-width: 1024px)";

/**
 * Returns `true` when the viewport is below the desktop breakpoint (< 1024px).
 * Uses `matchMedia` with an event listener so it reacts to live resizing and
 * orientation changes.
 */
export function useIsMobile(): boolean {
	const [isMobile, setIsMobile] = useState(() => {
		if (typeof window === "undefined") return false;
		return !window.matchMedia(DESKTOP_BREAKPOINT).matches;
	});

	useEffect(() => {
		const mql = window.matchMedia(DESKTOP_BREAKPOINT);
		function handleChange(e: MediaQueryListEvent) {
			setIsMobile(!e.matches);
		}
		mql.addEventListener("change", handleChange);
		// Sync in case SSR value differed
		setIsMobile(!mql.matches);
		return () => mql.removeEventListener("change", handleChange);
	}, []);

	return isMobile;
}
